import {VersionVariants} from '@jobseeker/lotus/enums';
import type {JobListProps} from './type';

import V1 from './V1';
import V2 from './V2';
import Modern from './modern';
import Hirist from './hirist';
import HiristSavedJobs from './VHirist';

const componentMap: any = {};
componentMap[VersionVariants.VERSION_ONE] = V1;
componentMap[VersionVariants.VERSION_TWO] = V2;
componentMap[VersionVariants.VERSION_THREE] = Modern;
componentMap[VersionVariants.VERSION_HIRIST] = Hirist;
componentMap[VersionVariants.VERSION_SEVEN] = HiristSavedJobs;

const JobList = (props: JobListProps) => {
  let Component;
  
  if (Object.keys(componentMap).includes(props.variant)) {
    Component = componentMap[props.variant];
  } else {
    Component = componentMap[VersionVariants.VERSION_ONE];
  }
  return <Component {...props} />;
};

export default JobList;
